import "@polymer/polymer/polymer-legacy.js";
import "@polymer/paper-input/paper-input.js";
import "@polymer/paper-button/paper-button.js";
import "@polymer/iron-form/iron-form.js";
import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
class Success extends PolymerElement {
    static get template() {
        return html `
            <p style="font-weight: bold;">[[data.response.title]]</p>
            <p>[[data.response.detail]]</p>
        `;
    }
    static get is() {
        return "email-sent";
    }
    static get properties() {
        return {
            data: {
                type: Object,
                value: undefined,
                notify: true,
                observer: "_dataChanged",
            },
        };
    }
    _dataChanged() {
        console.log(`Success Data ${this.data.email}, ${this.data.firstName}, ${this.data.lastName}`);
    }
    ready() {
        super.ready();
    }
    resend() {
        this.makeQuery(this.data)
            .then((result) => {
            console.log(result);
        })
            .catch((error) => {
            console.log(error);
        });
    }
}
window.customElements.define(Success.is, Success);
//# sourceMappingURL=success.js.map